import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebook,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import "./hamburger.scss";

export default function Hamburger() {
  // Close the slide-down menu after any link is tapped — previously the
  // checkbox stayed checked and the menu covered the page you navigated to.
  const closeMenu = () => {
    const toggle = document.getElementById("nav-toggle");
    if (toggle) toggle.checked = false;
  };

  return (
    <div>
      <label className="hamburger-menu">
        <input type="checkbox" id="nav-toggle" />
      </label>

      <aside className="links-container">
        <nav className="links mobile-links">
          <Link to="/" onClick={closeMenu}>
            <h1>Home</h1>
          </Link>
          <Link to="/instructors" onClick={closeMenu}>
            <h1>Instructors</h1>
          </Link>
          <Link to="/schedule" onClick={closeMenu}>
            <h1>Schedules</h1>
          </Link>
          <Link to="/reviews" onClick={closeMenu}>
            <h1>Reviews</h1>
          </Link>
          <Link to="/#programs" onClick={closeMenu}>
            <h1>Programs</h1>
          </Link>
          <Link to="/#trial" onClick={closeMenu} className="mobile-cta">
            <h1>Free Trial</h1>
          </Link>
        </nav>
        <div className="mobile-socials">
          <a
            href="https://www.facebook.com/baskingridgeskytkd/"
            target="_blank"
            rel="noreferrer"
            aria-label="Sky Taekwondo on Facebook"
          >
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a
            href="https://www.youtube.com/@skytaekwondo770"
            target="_blank"
            rel="noreferrer"
            aria-label="Sky Taekwondo on YouTube"
          >
            <FontAwesomeIcon icon={faYoutube} />
          </a>
          <a
            href="https://www.instagram.com/skytaekwondonj/"
            target="_blank"
            rel="noreferrer"
            aria-label="Sky Taekwondo on Instagram"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>
      </aside>
    </div>
  );
}
